import { userDate, isAfter, isBefore, isEqual, startOfDay } from 'owa-datetime';
import { computed } from 'mobx';
import getStore from './store';
import type { OwaDate } from 'owa-datetime';

const now = computed(() => (getStore().now, userDate()));
export const observableNow = (): OwaDate => now.get();

const today = computed(() => userDate(getStore().today));
export const observableToday = (): OwaDate => today.get();

export const isPastTime = (date: OwaDate): boolean => isBefore(date, observableNow());
export const isFutureTime = (date: OwaDate): boolean => isAfter(date, observableNow());

export const isPastDate = (date: OwaDate): boolean => compareWithToday(date, isBefore);
export const isFutureDate = (date: OwaDate): boolean => compareWithToday(date, isAfter);
export const isToday = (date: OwaDate): boolean => compareWithToday(date, isEqual);

const compareWithToday = (date: OwaDate, fn: typeof isAfter) =>
    fn(startOfDay(userDate(date)), observableToday());
